module.exports = __webpack_public_path__ + "assets/img/start.fb54e56e.webp";